export const supportedLanguages = ["en", "de", "es", "fr", "ja", "pt"];
